import React from 'react';
import Hero from '../components/sections/Hero';
import StatsSection from '../components/sections/StatsSection';
import ServicesGrid from '../components/sections/ServicesGrid';
import WhyChooseUs from '../components/sections/WhyChooseUs';
import ProjectsSection from '../components/sections/ProjectsSection';
import EvolutionTimeline from '../components/sections/EvolutionTimeline';
import PreFooterCta from '../components/sections/PreFooterCta'; // Import the new CTA

const Home = () => {
  return (
    <div>
      <Hero />
      <StatsSection />
      <ServicesGrid />
      <WhyChooseUs />
      <ProjectsSection />
      <EvolutionTimeline />
      <PreFooterCta /> {/* Placed right before the footer */}
    </div>
  );
};

export default Home;